// Web port of app/src/contexts/JsonApi.js — keep in sync with it.
//
// The mobile provider is platform-agnostic (react + darwin_core's jsonApiSetup,
// no React Native), so its logic is copied near-verbatim. It builds the
// devour-client REST client once on mount and exposes it via context; feature
// code reads it through useJsonApi(). The client authenticates each request
// itself (a Cognito middleware calls aws-amplify/auth fetchAuthSession), so it
// needs no auth wiring here — it just needs the user to be signed in when a
// request is actually made.
import { createContext, useContext, useEffect, useState } from 'react';

import { jsonApiSetup } from 'darwin_core';

export const JsonApiContext = createContext({ jsonApi: undefined });

export function JsonApiProvider({ children }) {
  const [jsonApi, setJsonApi] = useState();

  // Built in a mount effect (mirroring mobile) so the client is created exactly
  // once per provider lifetime; consumers see `undefined` until it is ready and
  // must guard on that (the store bootstrap does).
  useEffect(() => {
    setJsonApi(jsonApiSetup());
  }, []);

  return (
    <JsonApiContext.Provider value={{ jsonApi }}>
      {children}
    </JsonApiContext.Provider>
  );
}

// Consumer hook. Returns `{ jsonApi }`; jsonApi is undefined until the mount
// effect has run, matching the mobile context's shape.
export function useJsonApi() {
  return useContext(JsonApiContext);
}
